<ng-container *ngIf="state$ | async as state">

  <app-page-title-bar [text]="state.title"></app-page-title-bar>

  <app-page-container>
    <app-tab-informacion></app-tab-informacion>
  </app-page-container>
</ng-container>
